import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { DescopeSSOMappingsAttributes, ISSOMapping } from 'types/settings';
import AttributeMappingsRow from './AttributeMappingsRow';

interface IAttributeMappingsProps {
	formik: any;
}

const createAttributeMapping = (data?: ISSOMapping) =>
	Object.keys(data || {}).map((k) => ({
		value: k as DescopeSSOMappingsAttributes,
		idpValue: data![k as DescopeSSOMappingsAttributes] || ''
	})) || [];

const AttributeMappings: React.FC<IAttributeMappingsProps> = ({ formik }) => {
	const [currentMapping, setCurrentMapping] = useState<
		{ value: DescopeSSOMappingsAttributes; idpValue: string }[]
	>(createAttributeMapping(formik.initialValues.samlMappings));

	useEffect(() => {
		setCurrentMapping(
			createAttributeMapping(formik.initialValues.samlMappings)
		);
	}, [formik.initialValues.samlMappings, setCurrentMapping]);

	const handleAddMappings = useCallback(() => {
		setCurrentMapping([
			...currentMapping,
			{
				idpValue: '',
				value: DescopeSSOMappingsAttributes.Email
			}
		]);
	}, [setCurrentMapping, currentMapping]);

	const handleDeleteMappings = useCallback(
		(index: number) => () => {
			currentMapping.splice(index, 1);
			setCurrentMapping(currentMapping);

			formik.setFieldValue(
				'samlMappings',
				currentMapping.reduce(
					(prev, curr) => ({
						...prev,
						[curr.value]: curr.idpValue
					}),
					{}
				)
			);
		},
		[currentMapping, setCurrentMapping, formik]
	);

	const handleUpdateMappings = useCallback(
		(index: number) =>
			(idpValue: string, value: DescopeSSOMappingsAttributes) => {
				currentMapping[index] = {
					idpValue,
					value
				};
				setCurrentMapping(currentMapping);

				formik.setFieldValue(
					'samlMappings',
					currentMapping.reduce(
						(prev, curr) => ({
							...prev,
							[curr.value]: curr.idpValue
						}),
						{}
					)
				);
			},
		[formik, currentMapping, setCurrentMapping]
	);

	return (
		<>
			{currentMapping
				.filter(({ value }) => value !== DescopeSSOMappingsAttributes.group)
				.map((v, i) => (
					/* eslint react/no-array-index-key: 0 */
					<AttributeMappingsRow
						key={`${i}`}
						idpValue={v.idpValue}
						value={v.value}
						onDelete={handleDeleteMappings(i)}
						onUpdate={handleUpdateMappings(i)}
					/>
				))}
			<Box pt={1}>
				<Button
					color="primary"
					startIcon={<AddIcon />}
					onClick={handleAddMappings}
				>
					{intl.tr('authMethods.SSO.user.mapping.attributes.add.link')}
				</Button>
			</Box>
		</>
	);
};

export default AttributeMappings;
